const clickOutside = function (el, callback, ignore) {
  ignore = ignore || null;

  const listener = function (e) {
    let targetElement = e.target;
    do {
      if (
        targetElement === el ||
        targetElement === ignore ||
        targetElement === null
      ) {
        return;
      }
      targetElement = targetElement.parentNode;
    } while (targetElement !== document);
    callback();
  };

  document.addEventListener('click', listener);
  return () => document.removeEventListener('click', listener);
};

export { clickOutside as default };
